
export function registerWidgetElement(name, renderFn, updatePropertyFn) {
    const customHtmlElement = class extends HTMLElement {
        constructor() {
            super();
            this.is = name;
            console && console.info("Created '" + name + "' custom tag");
            if (!window.__WIDGET_CACHE)
                window.__WIDGET_CACHE = {};
            if (!window.__WIDGET_CACHE[name]) {
                window.__WIDGET_CACHE[name] = document.createElement('div');
                for(var i = this.children.length - 1; i >= 0; i--) {
                    window.__WIDGET_CACHE[name].appendChild(this.children.item(i));
                }
                renderFn(window.__WIDGET_CACHE[name], this.attributes);
            }
        }
        connectedCallback() {
            console && console.info("Connected '" + name + "' custom tag");
            this.innerHTML = '';
            this.appendChild(window.__WIDGET_CACHE[name]);
        }
        attributeChangedCallback(name, oldValue, newValue) {
            updatePropertyFn(name, oldValue, newValue);
        }
    };
    window.customElements.define(name, customHtmlElement);
}